import React from 'react'
import PropTypes from 'prop-types'
import injectJss from 'react-jss'
import compose from 'recompose/compose'
import withHandlers from 'recompose/withHandlers'
import withProps from 'recompose/withProps'
import classNames from 'classnames'
import { Icon } from 'aria-viewer/common/components/Icon'
import Hotspot from '../hotspot/Hotspot'
import Textfit from 'react-textfit'
import CHECK_CIRCLE from 'public/assets/svg/check_circle.svg'
import UNCHECKED_CIRCLE from 'public/assets/svg/circle_unchecked.svg'
import FRESNEL from 'public/assets/svg/fresnel_small.png'

const style = theme => ({
    listItem: {
        display: 'flex',
        alignItems: 'center',
        padding: '15px 12px 15px 60px',
        background: `url(${UNCHECKED_CIRCLE}) no-repeat 20px center`,
        overflow: 'hidden',
        boxSizing: 'border-box',
        width: '100%',
        height: 60,
        opacity: 0,
        transition: 'all 2s',
        [theme.breakpoints.down('xs')]: {
            height: 88,
            padding: '15px 12px 15px 22px',
        },
        '&:hover': {
            backgroundColor: 'rgba(0,0,0,1)',
        },
        '&:hover.visited': {
            background: `black url(${CHECK_CIRCLE}) no-repeat 20px center`,
        },
        '&.active': {
            backgroundColor: 'black',
        },
        '&.visited': {
            background: `rgba(0,0,0,0.8) url(${CHECK_CIRCLE}) no-repeat 20px center`,
        },
        '&.expanded': {
            opacity: 1,
        },
    },
    listItemIcon: {
        backgroundColor: 'inherit',
        height: 39,
        width: 39,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        borderRadius: '50%',
        // mobile
        [theme.breakpoints.down('xs')]: {
            marginLeft: 35,
            height: 56,
            width: 56,
        },
    },
    icon: {
        color: '#fff',
        fontSize: '20px',
        transform: 'scale(0.75)',
    },
    listItemText: {
        display: 'flex',
        alignItems: 'center',
        fontSize: '14px',
        marginLeft: '20px',
        color: theme.palette.common.white,
        maxWidth: 165,
        height: '100%',
        wordWrap: 'break-word',
        // mobile
        [theme.breakpoints.down('xs')]: {
            fontSize: '19.2px',
        },
    },
})

const handlers = withHandlers({
    handleListItemClick: ({ onClickListItem }) => index => event => onClickListItem && onClickListItem(index),
})

const tStyle = {
    fresnel: {
        // https://css-tricks.com/tinted-images-multiple-backgrounds/
        zIndex: 509,
        width: '100%',
        height: '100%',
        opacity: '0.7',
        background: [
            `url(${FRESNEL})`,
            'radial-gradient(ellipse at 50% 30%, rgba(255,255,255,0) 0%,rgba(255,255,255,0) 39%,rgba(255,255,255,0.31) 57%,rgba(20,20,20,0.56) 72%,rgba(20,20,20,1) 98%)',
        ],
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'contain',
        filter: 'contrast(4) brightness(0.7)',
    },
    background: {
        height: '100%',
        width: '100%',
        backgroundColor: 'rgba(255, 255, 255, 0.5)',
        borderRadius: '50%',
        overflow: 'hidden',
    },
}

const TriggerIcon = injectJss(tStyle)(({ classes }) => (
    <div className={classes.background}>
        <div className={classes.fresnel} />
    </div>
))

const ListItem = ({ classes, currentState, isVisited, type, id, title, handleListItemClick, mediaType, isMobile }) => (
    <li
        className={classNames(classes.listItem, isVisited ? 'visited' : '', currentState)}
        onClick={handleListItemClick(id)}
    >
        <div className={classes.listItemIcon}>
            {type === 'triggers' ? (
                <TriggerIcon />
            ) : (
                <Hotspot type={type === 'hotspots' ? mediaType : type} currentState={'list'} />
            )}
        </div>

        <Textfit className={classes.listItemText} mode="multi" max={isMobile ? 20 : 14} min={12} throttle={100}>
            {title}
        </Textfit>
    </li>
)

export default compose(
    handlers,
    injectJss(style)
)(ListItem)
